import { render, staticRenderFns } from "./AdministrationPotential.vue?vue&type=template&id=8ef73630"
import script from "./AdministrationPotential.vue?vue&type=script&lang=js"
export * from "./AdministrationPotential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports